import { render, staticRenderFns } from "./OrderGoodsLink.vue?vue&type=template&id=29b3ab60&scoped=true&"
import script from "./OrderGoodsLink.vue?vue&type=script&lang=js&"
export * from "./OrderGoodsLink.vue?vue&type=script&lang=js&"
import style0 from "./OrderGoodsLink.vue?vue&type=style&index=0&id=29b3ab60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b3ab60",
  null
  
)

export default component.exports